// removed by extract-text-webpack-plugin
module.exports = {"backdrop":"backdrop-3rZ-S","transparent":"transparent-zJcpA backdrop-3rZ-S"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/backdrops/styles.scss
 ** module id = 6
 ** module chunks = 0
 **/